import { createFileRoute, redirect } from '@tanstack/react-router';

// The edit page used to PATCH `/api/settings/notifications` against the
// dead monolith. Now that the read side is a coming-soon placeholder
// (notifications.tsx), allowing the edit child to render would mean
// users could submit toggles to a 404. Redirect to the parent until the
// backend is rebuilt.
export const Route = createFileRoute('/_dashboard/dashboard/settings/notifications/edit')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/notifications', replace: true });
  },
  component: () => null,
});
